import { render, staticRenderFns } from "./modularMenu.vue?vue&type=template&id=54ef7228&scoped=true"
import script from "./modularMenu.vue?vue&type=script&lang=js"
export * from "./modularMenu.vue?vue&type=script&lang=js"
import style0 from "./modularMenu.vue?vue&type=style&index=0&id=54ef7228&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef7228",
  null
  
)

export default component.exports